import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Login from './components/Login';
import MainLayout from './components/Layouts/MainLayout';
import Home from './components/Home';
import Profile from './pages/Profile';
import ForgotPassword from './components/ForgotPassword';
import Authorized from './pages/Authorized';
import Tickets from './pages/Tickets';
import FeedbackPage from './pages/FeedbackPage';
import PurchasedWithStripe from './pages/Purchased';
import Accounting from './pages/Accounting';
import LangJson from './pages/LangJson';
import Languages from './pages/Languages';
import ChangePassword from './pages/ChangePassword';
import NotFound from './components/NotFound';
// Placeholder components for each menu route
const Purchased = () => <div>Purchased Page</div>;

// Safely select auth status with loose typing to satisfy linter in JS file
const selectIsAuthenticated = (state) => {
  const s = /** @type {any} */ (state);
  const reduxAuth = s?.auth?.isAuthenticated === true;
  let storageAuth = false;
  try {
    const pbAuth = JSON.parse(localStorage.getItem('pocketbase_auth') || '{}');
    storageAuth = Boolean(pbAuth?.record);
  } catch (_) {
    storageAuth = false;
  }
  return reduxAuth || storageAuth;
};

function App() {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  return (
    <Router>
      <Routes>
        {/* Root redirect based on auth status */}
        <Route path="/" element={<Navigate to={isAuthenticated ? "/home" : "/login"} replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/feedback/:ticketId" element={<FeedbackPage />} />
        <Route path="/langjson/:code" element={<LangJson />} />
        <Route
          path="/*"
          element={
            isAuthenticated ? (
              <MainLayout>
                <Routes>
                  <Route path="home" element={<Home />} />
                  <Route path="profile" element={<Profile />} />
                  <Route path="authorized" element={<Authorized />} />
                  <Route path="purchased" element={<PurchasedWithStripe />} />
                  <Route path="accounting" element={<Accounting />} />
                  <Route path="ticket" element={<Tickets />} />
                  <Route path="languages" element={<Languages />} />
                  <Route path="change-password" element={<ChangePassword />} />
                  <Route path="*" element={<Navigate to="/home" replace />} />
                </Routes>
              </MainLayout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App; 